import styled from '@emotion/styled';
import { mediaQuery } from '@styles/index';

export const Hero = styled.section`
  position: relative;
  height: 464px;
  overflow: hidden;
  background: linear-gradient(180deg, #000 0%, #010b41 100%);

  ${mediaQuery.uptoMobile} {
    height: 190px;
  }
`;

export const HeroBg = styled.img`
  position: absolute;
  left: 0;
  top: -29%;
  width: 100%;
  height: 129%;
  object-fit: cover;
  opacity: 0.4;

  ${mediaQuery.uptoMobile} {
    left: -31px;
    top: 0;
    width: 435px;
    height: 190px;
  }
`;

export const Glow = styled.img<{ $side: 'left' | 'right' }>`
  position: absolute;
  pointer-events: none;
  z-index: 0;

  ${({ $side }) =>
    $side === 'left'
      ? `
    left: -1.8%;
    bottom: 3%;
    width: 38%;
    height: 56%;
  `
      : `
    right: -6%;
    bottom: 2%;
    width: 39%;
    height: 58%;
  `}

  ${mediaQuery.uptoMobile} {
    ${({ $side }) =>
      $side === 'left'
        ? `
      left: -21px;
      bottom: auto;
      top: 94px;
      width: 177px;
      height: 88px;
    `
        : `
      right: auto;
      left: 217px;
      bottom: auto;
      top: 93px;
      width: 182px;
      height: 91px;
    `}
  }
`;

export const HeroProduct = styled.div<{ $side: 'left' | 'right' }>`
  position: absolute;
  overflow: hidden;
  pointer-events: none;
  z-index: 1;

  ${({ $side }) =>
    $side === 'left'
      ? `
    left: -5.8%;
    top: 12%;
    width: 42.2%;
    height: 96%;
  `
      : `
    right: -5.9%;
    top: 14.7%;
    width: 39.3%;
    height: 91%;
  `}

  ${mediaQuery.uptoMobile} {
    ${({ $side }) =>
      $side === 'left'
        ? `
      left: -5.4%;
      top: 25.8%;
      width: 54.2%;
      height: 79.5%;
    `
        : `
      right: -8%;
      top: 28.4%;
      width: 50.4%;
      height: 75%;
    `}
  }
`;

export const HeroProductImg = styled.img<{ $side: 'left' | 'right' }>`
  position: absolute;
  top: 0;
  height: 100%;
  max-width: none;

  ${({ $side }) =>
    $side === 'left'
      ? `
    left: 0;
    width: 195.49%;
  `
      : `
    left: -104.53%;
    width: 198.65%;
  `}
`;

export const Star = styled.img<{
  $top: string;
  $left?: string;
  $right?: string;
  $size: number;
}>`
  position: absolute;
  top: ${({ $top }) => $top};
  left: ${({ $left }) => $left || 'auto'};
  right: ${({ $right }) => $right || 'auto'};
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  z-index: 1;

  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

export const StarCluster = styled.img<{ $side: 'left' | 'right' }>`
  display: none;

  ${mediaQuery.uptoMobile} {
    display: block;
    position: absolute;
    z-index: 1;
    pointer-events: none;

    ${({ $side }) =>
      $side === 'left'
        ? `
      left: -2px;
      top: 54px;
    `
        : `
      left: 254px;
      top: 54px;
    `}
  }
`;

export const HeroCopy = styled.div`
  position: relative;
  z-index: 2;
  max-width: 608px;
  margin: 128px auto 0;
  text-align: center;
  padding: 0 16px;

  ${mediaQuery.uptoMobile} {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    max-width: 235px;
    margin: 11px auto 0;
    padding: 0;
  }
`;

export const HeroLead = styled.p<{ $mobile?: boolean }>`
  margin: 0;
  font-size: 36px;
  font-weight: 400;
  line-height: 1.21;
  color: #fff;
  display: ${({ $mobile }) => ($mobile ? 'none' : 'block')};

  ${mediaQuery.uptoMobile} {
    display: ${({ $mobile }) => ($mobile ? 'block' : 'none')};
    font-size: 16px;
    font-weight: 400;
    line-height: 1.002;
  }
`;

export const HeroTitle = styled.p`
  margin: 0;
  font-size: 48px;
  font-weight: 700;
  line-height: 1.21;
  color: #fff;

  ${mediaQuery.uptoMobile} {
    font-size: 20px;
    line-height: 1.002;
    background: linear-gradient(180.43deg, #fff 34.68%, #f7c1d9 94.06%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
`;

export const PollHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;

  ${mediaQuery.uptoTablet} {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  ${mediaQuery.uptoMobile} {
    gap: 16px;
    width: 100%;
  }
`;

export const HintCard = styled.p`
  margin: 0;
  max-width: 335px;
  padding: 11px 16px;
  border-radius: 14px;
  background: #1e0609;
  border: 1px solid #4f0d18;
  color: rgba(255, 255, 255, 0.7);
  font-size: 18px;
  line-height: 1.36;
  letter-spacing: 0.02em;

  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

export const HintText = styled.p`
  display: none;
  margin: 0;
  font-size: 12px;
  line-height: 1.36;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.7);

  ${mediaQuery.uptoMobile} {
    display: block;
  }
`;

export const PollIntro = styled.div`
  ${mediaQuery.uptoMobile} {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }
`;

export const PollTitleBlock = styled.div`
  ${mediaQuery.uptoMobile} {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    h2 {
      margin-top: 0;
    }
  }
`;

export const PollGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 24px;
  margin-top: 36px;
  align-items: stretch;

  ${mediaQuery.uptoTablet} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    margin-top: 36px;
    gap: 12px;
  }
`;

export const PollCard = styled.button<{ $selected: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  text-align: left;
  gap: 31px;
  min-height: 306px;
  padding: 16px;
  border-radius: 16px;
  background: #211113;
  border: ${({ $selected }) =>
    $selected ? '1.5px solid rgba(244, 52, 72, 0.5)' : '1px solid #461b20'};
  box-shadow: ${({ $selected }) =>
    $selected ? 'inset 0 0 39px rgba(246, 59, 77, 0.34)' : 'none'};
  color: inherit;
  cursor: pointer;

  ${mediaQuery.uptoTablet} {
    min-height: 0;
    height: 100%;
    padding: 8px;
    gap: 31px;
    border-radius: 16px;
  }
`;

export const Radio = styled.span<{ $selected: boolean }>`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${({ $selected }) =>
    $selected ? '#f43448' : 'rgba(255,255,255,0.11)'};
  border: ${({ $selected }) => ($selected ? '0' : '2px solid #f2e9e9')};
  z-index: 1;

  &::after {
    content: '';
    display: ${({ $selected }) => ($selected ? 'block' : 'none')};
    width: 8px;
    height: 8px;
    margin: 6px auto;
    border-radius: 50%;
    background: #fff;
  }

  ${mediaQuery.uptoTablet} {
    top: 8px;
    right: 8px;
    width: 24px;
    height: 24px;

    &::after {
      width: 8px;
      height: 8px;
      margin: 8px auto;
    }
  }
`;

export const OptionBlock = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  gap: 18px;
  min-height: 0;
`;

export const OptionCopy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const OptionTitle = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 1;

  ${mediaQuery.uptoTablet} {
    font-size: 14px;
    line-height: 1.002;
  }
`;

export const OptionSub = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.7);

  ${mediaQuery.uptoTablet} {
    font-size: 12px;
    line-height: 1.002;
  }
`;

export const MeterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  margin-top: auto;
`;

export const MeterTrack = styled.div`
  flex: 1;
  height: 14px;
  border-radius: 14px;
  background: rgba(217, 217, 217, 0.2);
  overflow: hidden;
`;

export const MeterFill = styled.div<{ $value: number }>`
  width: ${({ $value }) => `${$value}%`};
  height: 100%;
  border-radius: 14px;
  background: linear-gradient(90deg, #ff5a73 0%, #f43448 100%);
`;

export const MeterValue = styled.span`
  font-size: 16px;
  line-height: 0.83;
  color: rgba(255, 255, 255, 0.7);
`;
